/* eslint-disable @stylexjs/no-unused -- styles are looked up by runtime key */
import * as stylex from '@stylexjs/stylex';
import { theme } from 'trellis-theming/theme.stylex';
const marginBlockStyles = {
  "0": {
    marginBlock: "x866bh7",
    marginTop: null,
    marginBottom: null,
    $$css: true
  },
  "100": {
    marginBlock: "x1licjgx",
    marginTop: null,
    marginBottom: null,
    $$css: true
  },
  "200": {
    marginBlock: "x1x1sxb",
    marginTop: null,
    marginBottom: null,
    $$css: true
  },
  "300": {
    marginBlock: "x6zseco",
    marginTop: null,
    marginBottom: null,
    $$css: true
  },
  "400": {
    marginBlock: "xy1ta4t",
    marginTop: null,
    marginBottom: null,
    $$css: true
  },
  "600": {
    marginBlock: "xc4a6le",
    marginTop: null,
    marginBottom: null,
    $$css: true
  },
  "800": {
    marginBlock: "xr13kb1",
    marginTop: null,
    marginBottom: null,
    $$css: true
  }
};
const marginBlockStartStyles = {
  "0": {
    marginTop: "x155yy3l",
    $$css: true
  },
  "100": {
    marginTop: "xp050ak",
    $$css: true
  },
  "200": {
    marginTop: "xfekf6i",
    $$css: true
  },
  "300": {
    marginTop: "x1ni6mix",
    $$css: true
  },
  "400": {
    marginTop: "x1nmqnbi",
    $$css: true
  },
  "600": {
    marginTop: "xj0smu1",
    $$css: true
  },
  "800": {
    marginTop: "x1qr4740",
    $$css: true
  }
};
const marginBlockEndStyles = {
  "0": {
    marginBottom: "x1fd4wat",
    $$css: true
  },
  "100": {
    marginBottom: "xzm6cv2",
    $$css: true
  },
  "200": {
    marginBottom: "x7vqod3",
    $$css: true
  },
  "300": {
    marginBottom: "x1qgg3u0",
    $$css: true
  },
  "400": {
    marginBottom: "xbervng",
    $$css: true
  },
  "600": {
    marginBottom: "xots3vl",
    $$css: true
  },
  "800": {
    marginBottom: "x6b0qdr",
    $$css: true
  }
};
const marginInlineStyles = {
  "0": {
    marginInline: "x1nslej5",
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    $$css: true
  },
  "100": {
    marginInline: "xhqhiy8",
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    $$css: true
  },
  "200": {
    marginInline: "x1fie8z3",
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    $$css: true
  },
  "300": {
    marginInline: "xouzovm",
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    $$css: true
  },
  "400": {
    marginInline: "x1w4d6r1",
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    $$css: true
  },
  "600": {
    marginInline: "x1ls5k6g",
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    $$css: true
  },
  "800": {
    marginInline: "x1oxhrdy",
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    $$css: true
  }
};
const marginInlineStartStyles = {
  "0": {
    marginInlineStart: "xs7sr93",
    marginLeft: null,
    marginRight: null,
    $$css: true
  },
  "100": {
    marginInlineStart: "xia198q",
    marginLeft: null,
    marginRight: null,
    $$css: true
  },
  "200": {
    marginInlineStart: "x1lecetj",
    marginLeft: null,
    marginRight: null,
    $$css: true
  },
  "300": {
    marginInlineStart: "x4bvc99",
    marginLeft: null,
    marginRight: null,
    $$css: true
  },
  "400": {
    marginInlineStart: "x1ocenht",
    marginLeft: null,
    marginRight: null,
    $$css: true
  },
  "600": {
    marginInlineStart: "x14fse72",
    marginLeft: null,
    marginRight: null,
    $$css: true
  },
  "800": {
    marginInlineStart: "x1cjlyrh",
    marginLeft: null,
    marginRight: null,
    $$css: true
  }
};
const marginInlineEndStyles = {
  "0": {
    marginInlineEnd: "x1qqae4",
    marginLeft: null,
    marginRight: null,
    $$css: true
  },
  "100": {
    marginInlineEnd: "xm4u3c4",
    marginLeft: null,
    marginRight: null,
    $$css: true
  },
  "200": {
    marginInlineEnd: "xxj5nmu",
    marginLeft: null,
    marginRight: null,
    $$css: true
  },
  "300": {
    marginInlineEnd: "x18vbul1",
    marginLeft: null,
    marginRight: null,
    $$css: true
  },
  "400": {
    marginInlineEnd: "xh522qj",
    marginLeft: null,
    marginRight: null,
    $$css: true
  },
  "600": {
    marginInlineEnd: "x16i5gv0",
    marginLeft: null,
    marginRight: null,
    $$css: true
  },
  "800": {
    marginInlineEnd: "xxjam05",
    marginLeft: null,
    marginRight: null,
    $$css: true
  }
};
const MARGIN_STYLES = {
  marginBlock: marginBlockStyles,
  marginBlockStart: marginBlockStartStyles,
  marginBlockEnd: marginBlockEndStyles,
  marginInline: marginInlineStyles,
  marginInlineStart: marginInlineStartStyles,
  marginInlineEnd: marginInlineEndStyles
};
const MARGIN_PROPS = Object.keys(MARGIN_STYLES);
export const toMarginXstyle = props => MARGIN_PROPS.flatMap(prop => {
  const value = props[prop];
  const styles = MARGIN_STYLES[prop];
  const style = value === undefined ? undefined : styles[value];
  return style ? [style] : [];
});
const paddingBlockStyles = {
  "0": {
    paddingBlock: "xqeb2wv",
    paddingTop: null,
    paddingBottom: null,
    $$css: true
  },
  "100": {
    paddingBlock: "x1tjmji",
    paddingTop: null,
    paddingBottom: null,
    $$css: true
  },
  "200": {
    paddingBlock: "x1t64xq4",
    paddingTop: null,
    paddingBottom: null,
    $$css: true
  },
  "300": {
    paddingBlock: "x197r2rs",
    paddingTop: null,
    paddingBottom: null,
    $$css: true
  },
  "400": {
    paddingBlock: "x7lf7rr",
    paddingTop: null,
    paddingBottom: null,
    $$css: true
  },
  "600": {
    paddingBlock: "xgar8lg",
    paddingTop: null,
    paddingBottom: null,
    $$css: true
  },
  "800": {
    paddingBlock: "xn9lapk",
    paddingTop: null,
    paddingBottom: null,
    $$css: true
  }
};
const paddingBlockStartStyles = {
  "0": {
    paddingTop: "x1qcmqgu",
    $$css: true
  },
  "100": {
    paddingTop: "xanyfzq",
    $$css: true
  },
  "200": {
    paddingTop: "xekf4lb",
    $$css: true
  },
  "300": {
    paddingTop: "x1qav0ai",
    $$css: true
  },
  "400": {
    paddingTop: "x1ataenr",
    $$css: true
  },
  "600": {
    paddingTop: "x10aeqxo",
    $$css: true
  },
  "800": {
    paddingTop: "xp5cksj",
    $$css: true
  }
};
const paddingBlockEndStyles = {
  "0": {
    paddingBottom: "x1qdhx5h",
    $$css: true
  },
  "100": {
    paddingBottom: "x1f4c75z",
    $$css: true
  },
  "200": {
    paddingBottom: "x11adobf",
    $$css: true
  },
  "300": {
    paddingBottom: "xbl200i",
    $$css: true
  },
  "400": {
    paddingBottom: "xevd588",
    $$css: true
  },
  "600": {
    paddingBottom: "x19cyq5f",
    $$css: true
  },
  "800": {
    paddingBottom: "xtt0yn6",
    $$css: true
  }
};
const paddingInlineStyles = {
  "0": {
    paddingInline: "x11sn8c9",
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    $$css: true
  },
  "100": {
    paddingInline: "x1ie7g4c",
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    $$css: true
  },
  "200": {
    paddingInline: "x1d16vy4",
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    $$css: true
  },
  "300": {
    paddingInline: "xt8hbjd",
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    $$css: true
  },
  "400": {
    paddingInline: "x3q6znv",
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    $$css: true
  },
  "600": {
    paddingInline: "x10kkatn",
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    $$css: true
  },
  "800": {
    paddingInline: "x1dvt03j",
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    $$css: true
  }
};
const paddingInlineStartStyles = {
  "0": {
    paddingInlineStart: "x1mncieb",
    paddingLeft: null,
    paddingRight: null,
    $$css: true
  },
  "100": {
    paddingInlineStart: "xu1e6gv",
    paddingLeft: null,
    paddingRight: null,
    $$css: true
  },
  "200": {
    paddingInlineStart: "xk86k8f",
    paddingLeft: null,
    paddingRight: null,
    $$css: true
  },
  "300": {
    paddingInlineStart: "xkwg8mk",
    paddingLeft: null,
    paddingRight: null,
    $$css: true
  },
  "400": {
    paddingInlineStart: "x8mq1xk",
    paddingLeft: null,
    paddingRight: null,
    $$css: true
  },
  "600": {
    paddingInlineStart: "x5781av",
    paddingLeft: null,
    paddingRight: null,
    $$css: true
  },
  "800": {
    paddingInlineStart: "x16u50sb",
    paddingLeft: null,
    paddingRight: null,
    $$css: true
  }
};
const PADDING_STYLES = {
  paddingBlock: paddingBlockStyles,
  paddingBlockStart: paddingBlockStartStyles,
  paddingBlockEnd: paddingBlockEndStyles,
  paddingInline: paddingInlineStyles,
  paddingInlineStart: paddingInlineStartStyles
};
const PADDING_PROPS = Object.keys(PADDING_STYLES);
export const toPaddingXstyle = props => PADDING_PROPS.flatMap(prop => {
  const value = props[prop];
  const styles = PADDING_STYLES[prop];
  const style = value === undefined ? undefined : styles[value];
  return style ? [style] : [];
});